<template>
  <v-container fluid grid-list-md py1>
    <v-layout row wrap>
      <v-flex md4>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ $t("view.generales.archivos.title") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <v-flex v-show="view.elem.showForm" class="py-0">
              <v-card-text>
                <form onSubmit="return false;" @submit="submit" @keyup.ctrl.83="executeValidators">
                  <!-- Clave -->
                  <v-text-field v-if="archivo.clave" v-model="archivo.clave" :label="$t('view.commons.clave')" disabled />

                  <!-- Descripcion -->
                  <v-text-field
                    v-model.trim="$v.archivo.descripcion.$model"
                    :label="$t('view.generales.archivos.form.descripcion.label')"
                    :error-messages="getFirstErrorDescription($v.archivo.descripcion)"
                    maxlength="255"
                    :disabled="view.action.submit.busy" />

                  <!-- Tipo -->
                  <v-flex md12>
                    <v-select
                      v-model.trim="$v.archivo.tipo.$model"
                      :label="$t('view.generales.archivos.form.tipo.label')"
                      :items="view.elem.select.tipo.filteredList"
                      disabled
                      item-value="code"
                      item-text="name"
                      :error-messages="getFirstErrorDescription($v.archivo.tipo)" />
                  </v-flex>

                  <!-- Subtipo -->
                  <v-flex md12>
                    <v-select
                      v-model.trim="$v.archivo.subtipo.$model"
                      :label="$t('view.generales.archivos.form.subtipo.label')"
                      :items="listadoSubTipo"
                      disabled
                      item-value="code"
                      item-text="name"
                      :error-messages="getFirstErrorDescription($v.archivo.subtipo)" />
                  </v-flex>

                  <!-- Estatus -->
                  <label class="v-label mt-3">{{ $t("view.commons.status") }}</label>
                  <v-switch v-model="archivo.status" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                </form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-flex shrink>
                  <v-btn
                    v-show="archivo.clave && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
                    id="btnaudit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="$t('view.commons.audit')"
                    :loading="view.action.submit.busy"
                    @click="audit()">
                    <v-icon small>storage</v-icon>
                  </v-btn>

                  <v-btn id="btnclear" fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
                    <v-icon small>fa-eraser</v-icon>
                  </v-btn>

                  <v-btn
                    v-show="archivo.clave && $userPermission.hasPermission('ROLE_MODIFICAR_CATALOGOS')"
                    id="btnsubmit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="view.elem.button.submit.title.current"
                    :loading="view.action.submit.busy"
                    :disabled="form.$state.isDisableButtonSubmit()"
                    @click="submit()">
                    <v-icon small>{{ view.elem.button.submit.class.current }}</v-icon>
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-flex>
          </v-expand-transition>
        </v-card>
      </v-flex>

      <v-flex md8>
        <data-table ref="archivosTable" @editRow="load" @auditRow="audit" />
      </v-flex>
    </v-layout>
    <auditoria ref="auditModal" />
  </v-container>
</template>
<script>
import archivosStates from "@/views/generales/archivos/archivos-state"; /** *******************************/
import archivosAPI from "@/services/generales/archivos"; /** *******************************/
import combosAPI from "@/services/catalogos"; /** *******************************/
import DataTable from "@/views/generales/archivos/DataTable"; /** *******************************/
import Auditoria from "@/components/auditoria/Auditoria"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required } from "vuelidate/lib/validators";
import { fixMigImp } from "@/helpers/vuelidate/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { TIPO_ARCHIVO_SELECT, TIPO_ARCHIVO_NUM_CANAL, TIPO_ARCHIVO_NUM_DIM, TIPO_ARCHIVO_NUM_IMPORT, TIPO_CANAL_SELECT, TIPO_DIM_SELECT, TIPO_IMPORT_SELECT } from "@/constants/operativos";
import { submit } from "@/constants/buttons";
import tippy from "tippy.js";

const select = {
  tipo: { filteredList: TIPO_ARCHIVO_SELECT }
  , subtipo: { filteredList: [] }
};

const action = { submit: { busy: false } };

export default {
  name: "ArchivoModule"
  , components: {
    DataTable
    , Auditoria
  }
  , data() {
    return {
      archivo: undefined
      , form: new Object()
      , view: {
        title: this.$t("view.generales.archivos.title")
        , action
        , elem: {
          button: { submit }
          , select
          , showForm: true
        }
      }
      , listadoArchivos: []
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , computed: {
    listadoSubTipo() {
      if (this.archivo.tipo === TIPO_ARCHIVO_NUM_CANAL) {
        return TIPO_CANAL_SELECT;
      } else if (this.archivo.tipo === TIPO_ARCHIVO_NUM_DIM) {
        return TIPO_DIM_SELECT;
      } else if (this.archivo.tipo === TIPO_ARCHIVO_NUM_IMPORT) {
        return TIPO_IMPORT_SELECT;
      } else {
        return [];
      }
    }
  }
  , created() {
    this.form = new archivosStates(this);
    this.form.$setState("initial");
    this.getArchivos();
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.archivo);
        handleResponse(respuesta, this.$t("iew.generales.archivos.errors"));
      } catch (error) {
        handleResponse(error, this.$t("iew.generales.archivos.errors"));
      }
    }
    , async load(clave) {
      try {
        const response = await archivosAPI.get(clave);
        const { data: { results: { archivos } } } = response;
        this.getArchivos();
        this.form.$setState("editing", archivos);
      } catch (error) {
        console.log(error);
      }
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , async audit(clave = this.archivo.clave, dataDescripcion = this.archivo.descripcion) {
      this.$refs.auditModal.loadAudit(clave, "TArchivos", dataDescripcion, this.view.title);
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        scrollToForm(this);
      }
    }
    , async getArchivos() {
      const { data: { results: { combo: reponseListArchivos } } } = await combosAPI.get({ option: "archivos" });
      this.listadoArchivos = reponseListArchivos;
    }
  }
  , validations: {
    archivo: {
      descripcion: { required, fixMigImp: fixMigImp() }
      , subtipo: { required }
      , tipo: { required }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/generales/archivos/Archivos.vue